export default "<meta http-equiv=\"Content-Security-Policy\" content=\"upgrade-insecure-requests\">\r\n<router-outlet></router-outlet>"